module.exports = __webpack_public_path__ + "assets/images/caretaker_g.f09c93e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/caretaker_g.png
// module id = 685
// module chunks = 1